import { gql, useLazyQuery } from '@apollo/client'

export interface KeyValueResponse {
  key: string
  amount: number
}

export interface CurrencyConvertTotals {
  totalConvertedQuantity: number
  totalConvertedBDNetAmount: number
  totalDiscountPercentageSum: number
  totalOGMPercentageSum: number
  totalEstimatedPnBdNetRevenueSum: number
}

export interface CurrencyConvertLineItem extends CurrencyConvertTotals {
  productNumber: string
  plCode: string
  lineNumber: number
  itemNumber: number
  plCategoryCd: string
  itemType: string
  lineType: string
  keyValueResponses: KeyValueResponse[]
}

export interface CurrencyConvertResponse {
  currencyConvertDecisionEditPage: CurrencyConvertLineItem[]
}

export interface CurrencyConvertVariables {
  dealId: number
  lineTypeCode?: string
  toCurrencyCode?: string
}

export const CURRENCY_CONVERT_DECISION_EDIT_PAGE = gql`
  query CurrencyConvertDecisionEditPage(
    $dealId: Int!
    $lineTypeCode: String
    $toCurrencyCode: String
  ) {
    currencyConvertDecisionEditPage(
      dealId: $dealId
      lineTypeCode: $lineTypeCode
      toCurrencyCode: $toCurrencyCode
    ) {
      productNumber
      plCode
      lineNumber
      itemNumber
      plCategoryCd
      itemType
      lineType
      totalConvertedQuantity
      totalConvertedBDNetAmount
      totalDiscountPercentageSum
      totalOGMPercentageSum
      totalEstimatedPnBdNetRevenueSum
      keyValueResponses {
        key
        amount
      }
    }
  }
`

export const useCurrencyConvertEditPage = () => {
  const [getCurrencyConversion, { data, loading, error }] = useLazyQuery<
    CurrencyConvertResponse,
    CurrencyConvertVariables
  >(CURRENCY_CONVERT_DECISION_EDIT_PAGE, {
    fetchPolicy: 'network-only',
  })

  return {
    getCurrencyConversion,
    data: data?.currencyConvertDecisionEditPage,
    loading,
    error,
  }
}
